module.exports = __webpack_public_path__ + "static/media/nav_jj_rb_bg.9357ef4c.png";